/**
 * @author Harshitha.k
 * @description 
 */

import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import HierarchyModal from './Utils/HierarchyModal';
import { UpSquareOutlined } from '@ant-design/icons';
import themeSettings from '../../../commons/styles/themeSettings.json';
import { Form, Select, Button, TimePicker, message, Modal, Checkbox } from 'antd';
import { API_ASSET, MAXIMOASSET, API_DEVICETYPE } from '../../../commons/api';
import {
  getListById,
  getListByType,
  submit,
  getHierarchyFromAPI,
  getDeviceList,
  getHierarchyFromAPIForAsset
} from './Utils/FormCalls';

const { Option } = Select;
const ApiList = {
  getAssetList: API_ASSET.GETASSETBYMODULE,
  getDeviceTypeListByAsset: `${API_DEVICETYPE.getDeviceTypeListByAsset}`,
  getDeviceListByDeviceType: `${MAXIMOASSET.DeviceList}`,
  getFaultCodesList: `${MAXIMOASSET.FaultCodeList}`,
  getFaultCodesListAsset: `${MAXIMOASSET.GetParamsByAsset}`,
  Submit: `${MAXIMOASSET.UpdateAFCDetails}`,
  SubmitAsset: `${MAXIMOASSET.UpdateParameterAsset}`
};

const SRHaltTime = (props) => {
  const [formObject, setFormObject] = useState({});
  const [hierarchy, setHierarchy] = useState('');
  const [deviceTypeList, setDeviceTypeList] = useState([]);
  const [deviceList, setDeviceList] = useState([]);
  const [treeVisible, setTreeVisible] = useState(false);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [assetChecked, setAssetChecked] = useState(false);
  const [deviceChecked, setDeviceChecked] = useState(true);
  const [typeValue, setTypeValue] = useState('Device');
  const [checkedValue, setCheckedValue] = useState([]);
  const [FaultCodesList, setFaultCodesList] = useState([]);
  const [FaultCodesListAsset, setFaultCodesListAsset] = useState([]);
  const [selectedDeviceObject,setSelectedDeviceObject] = useState('');
  const [Asset,setAsset] = useState('');
  const record = useState(
    props.location && props.location.state ? props.location.state.record : {}
  );

  const hRef = useRef();

  useEffect(() => {
    const fetchData = async () => {
      await getDataById();
      const data = hRef.current ? hRef.current.getFieldsValue() : null;
      await fieldOnChange(data.Station, 'Station');
      await fieldOnChange(data.deviceType, 'deviceType');
      await fieldOnChange(data.DeviceCode, 'DeviceCode');
      await getHierarchyData('Device');

      const deviceListData = await getDeviceList();
      setDeviceList(deviceListData);
      setFormObject(record);
    };
    fetchData();
  }, []);

  const getHierarchyData = async (type) => {
    const path = props.location.pathname.split('/rubus/Maximo/');
    const Module = path[1].split('/') && path[1].split('/')[0];
    const hierarchy = await getHierarchyFromAPI(Module, type);
    setHierarchy(hierarchy);
  };
   const getHierarchyDataForAsset = async (type) => {
    const path = props.location.pathname.split('/rubus/Maximo/');
    const Module = path[1].split('/') && path[1].split('/')[0];
    const AssetData = await getHierarchyFromAPIForAsset(Module, type);
    setAsset(AssetData);
  };

  const getDataById = async () => {
    const timeFrame = record.TimeFrame || [];
    const amsParameter = record.AmsParameter || [];
    const haltType = record.HaltType || [];

    const fromTimeFrame = timeFrame.length > 0 ? moment.utc(timeFrame[0], 'YYYY-MM-DD HH:mm:ss') : null;
    const toTimeFrame = timeFrame.length > 1 ? moment.utc(timeFrame[1], 'YYYY-MM-DD HH:mm:ss') : null;

    const formValues = {
      ...record,
      FromTimeFrame: fromTimeFrame,
      ToTimeFrame: toTimeFrame,
      ParameterCode: amsParameter,
      Type: haltType
    };

    if (hRef.current) {
      hRef.current.setFieldsValue(formValues);
    }
    setFormObject(formValues);
  };

    const fieldOnChange = async (value, key, checked, typeValue) => {
      let path = props.location.pathname.split('/rubus/Maximo/');
      let Module = path[1].split('/') && path[1].split('/')[0];
  
      if (value !== undefined) {
        if (key === 'Station') {
          let payload = { AssetCode: value };
          const deviceTypeList1 = await getListById(ApiList.getDeviceTypeListByAsset, payload, Module);
          
          setDeviceTypeList([
            ...(deviceTypeList1 && Array.isArray(deviceTypeList1) && deviceTypeList1.length > 0
              ? [{ AssetCode: 'All', AssetName: 'All', Code: 'All', Description: 'All' }]
              : []),
            ...deviceTypeList1
          ]);
          
          setFormObject(prev => ({ ...prev, [key]: value }));
        } else if (key === 'deviceType') {
          let payload = { Module: Module, AssetDeviceType: value };
          const deviceList1 = await getListByType(ApiList.getDeviceListByDeviceType, payload);
  
          setDeviceList([
            ...(deviceList1 && Array.isArray(deviceList1) && deviceList1.length > 0
              ? [{ AssetCode: 'All', DeviceName: 'All', DeviceCode: 'All', Description: 'All' }]
              : []),
            ...deviceList1
          ]);
  
          setFormObject(prev => ({ ...prev, [key]: value }));
        } else if (key === 'DeviceCode') {
          let payload;
          
          if (typeValue === 'Device') {
            payload = { Module: Module, DeviceCode: value, Type: typeValue };
            const FaultCodesList1 = await getListById(ApiList.getFaultCodesList, payload);
            
            setFaultCodesList([
              ...(FaultCodesList1 && Array.isArray(FaultCodesList1) && FaultCodesList1.length > 0
                ? [{ DeviceCode: 'All', Code: 'All', Description: 'All', DeviceName: 'All' }]
                : []),
              ...FaultCodesList1
            ]);
          } else if (typeValue === 'Asset') {
            payload = { Module: Module, AssetCode: value, Type: typeValue };
            const FaultCodesList2 = await getListById(ApiList.getFaultCodesListAsset, payload);
  
            setFaultCodesListAsset([
              ...(FaultCodesList2 && Array.isArray(FaultCodesList2) && FaultCodesList2.length > 0
                ? [{ DeviceCode: 'All', DeviceName: 'All', Code: 'All', Description: 'All' }]
                : []),
              ...FaultCodesList2
            ]);
          }
          
          setFormObject(prev => ({ ...prev, [key]: value }));
        } else if (key === 'HaltStatus') {
          setFormObject(prev => ({ ...prev, [key]: value }));
        }
      }
  
      if (hRef.current !== null) {
        hRef.current.setFieldsValue(formObject);
      }
      setDeviceTypeList(deviceTypeList);
      setSelectedDevices(checked);
    };
    
      const onFormsubmit = () => {
        const path = history.location.pathname.split('/rubus/Maximo/');
        const Module = path[1].split('/')[0];
    
        hRef.current
          .validateFields()
          .then(async (values) => {
            const TimeFrame = [values['FromTimeFrame'], values['ToTimeFrame']];
            let payload;
    
            if (formObject.Type === 'Asset') {
              payload = {
                TimeFrame: TimeFrame,
                AssetCode: typeValue === 'Asset' ? values['AssetCode'] : selectedDeviceObject,
                Module: Module,
                HaltStatus: values['HaltStatus'],
                ParameterCode: values['ParameterCode'],
                HaltType: values['Type'],
              };
              const response = await submit(ApiList.SubmitAsset, payload, typeValue);
              message.success(response.message);
            } else {
              payload = {
                TimeFrame: TimeFrame,
                DeviceCode: typeValue === 'Device' ? values['DeviceCode'] : selectedDeviceObject,
                Module: Module,
                HaltStatus: values['HaltStatus'],
                ParameterCode: values['ParameterCode'],
                HaltType: values['Type'],
              };
              const response = await submit(ApiList.Submit, payload, typeValue);
              message.success(response.message);
            }
          })
          .catch(() => {
            // Handle validation errors if needed
          });
      };

  const onModalsOk = (e) => {
    e.preventDefault();
    fieldOnChange(selectedDeviceObject, 'DeviceCode', checkedValue, typeValue);
    setTreeVisible(false);
  };

  const onModalCancel = () => {
    setTreeVisible(false);
  };

  const hierarchyDropdownChange = (value, data) => {
    setCheckedValue(value);
    setSelectedDeviceObject(data);
  };

  const checkboxOnChange = (e, type) => {
    setTypeValue(type);
    setAssetChecked(type === 'Asset' ? e.target.checked : false);
    setDeviceChecked(type === 'Device' ? e.target.checked : false);
    getHierarchyData(type);
  };

  const checkboxOnChangeAsset = (e, type) => {
    setTypeValue(type);
    setAssetChecked(type === 'Asset' ? e.target.checked : false);
    setDeviceChecked(type === 'Device' ? e.target.checked : false);
    getHierarchyDataForAsset(type);
  };

  return (
    <Form
      name="Equipment Master"
      theme={themeSettings}
      ref={hRef}
      onFinish={onFormsubmit}
      initialValues={formObject || {}}
      layout="horizontal"
      labelCol={{ flex: '250px' }}
      labelAlign="right"
      labelWrap
      validateMessages={{
        required: '${label} is required!',
        types: {
          email: '${label} is not a valid email!',
          number: '${label} is not a valid number!'
        },
        number: {
          range: '${label} must be between ${min} and ${max}'
        }
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'right' }}>
        <Form.Item>
          <Button theme={themeSettings} type="primary" htmlType="submit">
            {'Submit'}
          </Button>
        </Form.Item>
      </div>

      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        <Form.Item
          name={formObject.Type === 'Asset' ? 'AssetCode' : 'DeviceCode'}
          label={'Select Device'}
          rules={[{ required: false, message: 'Please Select Device!' }]}
          style={{ width: '100%', flex: '100%' }}
        >
          <span style={{ display: 'flex', justifyContent: 'flex-start' }}>
            <Select
              style={{ width: '75%', opacity: 1, pointerEvents: 'none' }}
              value={selectedDevices && selectedDevices.length ? selectedDevices : formObject.DeviceCode || formObject.AssetCode || []}
              mode="multiple"
              placeholder={'Select Device'}
              
            >
              {deviceList &&
                Array.isArray(deviceList) &&
                deviceList.map((device, index) => (
                  <Option key={index} value={`${device.DeviceCode}`}>
                    {device.Name}::{device.DeviceCode}
                  </Option>
                ))}
            </Select>
            <Button
              style={{ width: '5%' }}
              type="primary"
              onClick={() => setTreeVisible(true)}
              disabled={formObject && formObject.Id ? true : false}
            >
              <UpSquareOutlined />
            </Button>
          </span>
        </Form.Item>
        <Form.Item
          label="From Time"
          name="FromTimeFrame"
          rules={[{ required: true }]}
          style={{ width: '100%', flex: '100%' }}
        >
          <TimePicker
            value={formObject.FromTimeFrame}
            style={{ width: '80%' }}
            onChange={(value) => fieldOnChange(value, 'FromTimeFrame', checkedValue)}
          />
        </Form.Item>
        <Form.Item
          label="To Time"
          name="ToTimeFrame"
          rules={[{ required: true }]}
          style={{ width: '100%', flex: '100%' }}
        >
          <TimePicker
            value={formObject.ToTimeFrame}
            style={{ width: '80%' }}
            onChange={(value) => fieldOnChange(value, 'ToTimeFrame', checkedValue)}
          />
        </Form.Item>
        <Form.Item
          label="Type"
          name="Halt Type"
          rules={[{ required: true }]}
          style={{ width: '100%', flex: '100%' }}
        >
          <Select
            style={{ width: '80%' }}
            placeholder="Please select Type"
            onChange={(value) => fieldOnChange(value, 'Type', checkedValue)}
          >
            <Option value="Exclude">Exclude</Option>
            <Option value="Include">Include</Option>
          </Select>
        </Form.Item>
        <Form.Item
          label="Parameter Code"
          name="ParameterCode"
          style={{ width: '100%', flex: '100%' }}
        >
          <Select
            placeholder="Please select Fault Code"
            style={{ width: '80%' }}
            mode={'multiple'}
            value={formObject.AmsParameter}
            onChange={(value) => fieldOnChange(value, 'ParameterCode', checkedValue)}
            disabled={formObject && formObject.Id ? true : false}
          >
            {(typeValue === 'Device' ? FaultCodesList : FaultCodesListAsset).map((item, index) => (
              <Option key={index} value={item.Code !== 'All' ? `${item.DeviceCode}$$$${item.Code}` : 'All'}>
                {item.Code !== 'All' ? `${item.Description}@${item.DeviceName}` : 'All'}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="Status"
          name="HaltStatus"
          style={{ width: '100%', flex: '100%' }}
          rules={[{ required: true }]}
        >
          <Select
            placeholder="Please select Status"
            style={{ width: '80%' }}
          >
            <Option key={'Enabled'} value={true}>
              {'Enabled'}
            </Option>
            <Option key={'Disabled'} value={false}>
              {'Disabled'}
            </Option>
          </Select>
        </Form.Item>
        <Form.Item name={'Key'} style={{ width: '100%', flex: '100%' }}></Form.Item>
        <Modal
          open={treeVisible}
          width={800}
          closable
          title={'Select Device'}
          okText={'Add'}
          onOk={onModalsOk}
          onCancel={onModalCancel}
        >
          <div>
            <Checkbox
              value="Asset"
              checked={assetChecked}
              onChange={(e) => checkboxOnChangeAsset(e, 'Asset')}
            >
              Asset
            </Checkbox>
            <Checkbox
              value="Device"
              checked={deviceChecked}
              onChange={(e) => checkboxOnChange(e, 'Device')}
            >
              Device
            </Checkbox>
          </div>
          <HierarchyModal
            selectedDevice={selectedDevices ?selectedDevices :[]}
            treeData={ hierarchy && deviceChecked === true ? hierarchy : Asset }
            Key="Trends"
            handleDropdownChange={hierarchyDropdownChange}
            checkedArray={checkedValue ? checkedValue : []}
          />
        </Modal>
      </div>
    </Form>
  );
};

export default SRHaltTime;